<template>
  <div class="div">
    <div class="row">
        <div class="col-md-12">
            <div class="card p-5">
                <div class="row">
                    <div class="col-md-12">
                        <h3 v-if="numError > 0" class="title" style="color: red;">Errores: {{numError}}</h3>
                        <h3 v-if="numError == 0" class="title text-center mt-3 mb-3" style="color: #00b2e3">Tu archivo se encuentra correcto</h3>
                        <p v-if="numError > 0">Da clic en editar o eliminar para corregir el registro; usa como guía los códigos de color para ubicar los posibles errores.</p>
                        <p v-if="numError == 0" class="text-center">Da clic en el botón “alta de asegurados” para continuar con el proceso.</p>
                    </div>
                    <!-- <div class="col-md-2">
                        <div class="row">
                            <div class="col-sm-2 col-md-6">
                                <button disabled type="button" class="btn btn-outline-link" style="border-radius: 70px; height: 76px; border-color: rgb(197, 194, 194);">
                                    <img src="img/cotizador_APE/Carga individual.png" class="mr-1 ml-1" alt="" style="height: 40px;"/>
                                </button>
                            </div>
                            <div class="col-sm-3 col-md-6 mt-4">
                                <p style="font-size: 10px;">CARGA<br>INDIVIDUAL</p>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div v-if="numError > 0" class="row">
                  <div class="col-md-12">
                    <hr />
                  </div>
                </div>
                <div v-if="numError > 0" class="row">
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-1"><div class="circulo" style="background: #008000;"></div></div>
                            <div class="col"><p style="font-size: small;">Registro duplicado</p></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-1"><div class="circulo" style="background: #800080;"></div></div>
                            <div class="col"><p style="font-size: small;">Nombre (campo vacío)</p></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-1"><div class="circulo" style="background: #008B8B;"></div></div>
                            <div class="col"><p style="font-size: small;">Apellido paterno (campo vacío)</p></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-1"><div class="circulo" style="background: #FF0000;"></div></div>
                            <div class="col"><p style="font-size: small;">Apellido materno (campo vacío)</p></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-1"><div class="circulo bordeCirculo" style="background: rgb(255, 255, 255);"></div></div>
                            <div class="col"><p style="font-size: small;">Sexo (campo vacío)</p></div>
                        </div>
                    </div>
                </div>
                <div v-if="numError > 0" class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col-1"><div class="circulo bordeCirculo" style="background: #FFFF00;"></div></div>
                            <div class="col"><p style="font-size: small;">Edad menor a 45 días (fecha de nacimiento)</p></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-1"><div class="circulo bordeCirculo" style="background: #FF0000;"></div></div>
                            <div class="col"><p style="font-size: small;">Edad mayor a 69 años (fecha de nacimiento)</p></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-1"><div class="circulo" style="background: #00b2e3;"></div></div>
                            <div class="col"><p style="font-size: small;">Ya se encuentra dado de alta</p></div>
                        </div>
                    </div>
                </div>
                <div v-if="numError > 0" class="row">
                  <div class="col-md-12">
                    <hr />
                  </div>
                </div>
                <div v-if="numError > 0"  class="row mt-2 table-responsive">
                    <table id="tableExcel" class="table ">
                        <thead>
                            <tr>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col">Apellido Paterno</th>
                            <th scope="col">Apellido Materno</th>
                            <th scope="col">Nombres</th>
                            <th scope="col">Sexo</th>
                            <th scope="col">Fecha de nacimiento</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in camposError" :key="i" 
                            :class="item.Editar ? 'editar' : item.ErrorDetectado == 'El Campo ApellidoPaterno es Requerido' ? 'apellidopVacio' 
                            : item.ErrorDetectado == 'El Campo ApellidoMaterno es Requerido' ? 'apellidomVacio' 
                            : item.ErrorDetectado == 'El Campo Nombres es Requerido' ? 'nombreVacio' 
                            : item.SexoMF == null ? 'sexoVacio' : item.FechadeNacimientodiamesaño == null ? 'edadMenor' 
                            : item.ErrorDetectado == 'La fecha es menor de 45 días' ? 'edadMenor'  
                            : item.ErrorDetectado == 'La fecha es mayor de 69 años' ? 'edadMayor' 
                            :item.Color3 == 'EB21B6' ?'c_diferentes' 
                            : item.Color3 == '008000' ? 'dupicado' : ''">

                                <td  :style="!item.Editar ? 'background-color: white;' : 'background-color: black;'">
                                    <button v-if="item.Editar"  type="button" class="btn btn-link btnTabla" @click="actualizarRegistro(item, i)" :style="!item.Editar ? 'color: #929191;' : 'color: #FFFF00;'">Actualizar</button>

                                    <button  v-if="!item.Editar" @click="editarRegistro(item, i)" type="button" class="btn btn-link btnTabla" :style="!item.Editar ? 'color: #929191;' : 'color: #FFFF00;'">Editar</button>
                                </td>

                                <td :style="!item.Editar ? 'background-color: white;' : 'background-color: black;'">
                                    <button type="button" class="btn btn-link btnTabla" :style="!item.Editar ? 'color: #929191;' : 'color: #FFFF00;'" @click="eliminar(i, item)">Eliminar</button>
                                </td>
                                <td :style="!item.Editar ? 'background-color: white;' : 'background-color: black;'">
                                    <CButton color="link" class="btnTabla" style="color: red;" ><b>{{ item.btnError }}</b></CButton>
                                    <!-- v-c-tooltip="{content: item.ErrorDetectado, placement: 'right'}" -->
                                </td>
                                <td :class="item.Editar ? 'editar' : ''">
                                    <p v-if="!item.Editar">{{ item.ApellidoPaterno}}</p>
                                    <input v-if="item.Editar" class="form-control" type="text" v-model="item.ApellidoPaterno">
                                </td>
                                <td :class="item.Editar ? 'editar' : ''">
                                    <p v-if="!item.Editar">{{ item.ApellidoMaterno}}</p>
                                    <input v-if="item.Editar" class="form-control" type="text" v-model="item.ApellidoMaterno" >
                                </td>
                                <td :class="item.Editar ? 'editar' : ''">
                                    <p v-if="!item.Editar">{{ item.Nombres}}</p>
                                    <input v-if="item.Editar" class="form-control" type="text" v-model="item.Nombres" >
                                </td>
                                <td :class="item.Editar ? 'editar' : ''">
                                    <p v-if="!item.Editar">{{ item.SexoMF }}</p>
                                    <select v-if="item.Editar" class="form-control" aria-label="Default select example" v-model="item.SexoMF" >
                                        <option selected>--Seleccione</option>
                                        <option value="F">F</option>
                                        <option value="M">M</option>
                                    </select>
                                </td>
                                <td :class="item.Editar ? 'editar' : ''">
                                    <p v-if="!item.Editar">{{ item.FechadeNacimientodiamesaño}}</p>
                                    <input v-if="item.Editar" class="form-control" type="date" v-model="item.fechaFormateada">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr />
                  </div>
                </div>
                <div class="row d-flex justify-content-between align-items-center">
                    <div class="col-md-6">
                        <p v-if="numError > 0">Para actualizar los cambios da clic en en el botón “actualizar”</p>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-outline-primary col-md-12" style="border-radius: 15px;" @click="regresar">
                            Regresar
                        </button>
                    </div>
                    <div class="col" v-if="numError > 0">
                        <button type="button" class="btn btn-primary col-md-12" style="border-radius: 15px;" @click="validarCargaActualizada">
                            Actualizar
                        </button>
                    </div>
                    <!-- <div class="col" v-if="numError == 0">
                        <button @click="modal.add = true" type="button" class="btn btn-primary col-md-12" style="border-radius: 15px;">
                            Cargar + asegurados
                        </button>
                    </div> -->
                    <div class="col"  v-if="numError == 0">
                        <button type="button" class="btn btn-info col-md-12" style="border-radius: 15px;" @click="grabarCarga">
                            Alta de asegurados
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- modal -->
    <div>
        <CModal :show.sync="modal.inicial" ref="my-modal" :close-on-backdrop="false">
            <template #header-wrapper >
                <div class="text-center mb-3" >
                    <div class="row">
                    <div class="col-10"></div>
                    <div class="col-1 mt-2">
                        <button v-if="cargaExito" type="button" class="btn-close ml-4" aria-label="Close" @click="modalClose"></button>
                        <!-- <button @click="modal.inicial = false" type="button" class="btn btn-light"> <i class="fas fa-times fa-2xl mt-3 mr-1" style="color:rgb(179, 173, 173);"></i></button> -->
                    </div>
                    </div>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
            <div class="card-body text-center">
            <img :src=imagen alt="" style="height: 90px;">
                <h3 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">{{ titulo }}</h3>
                <p class="mt-3">{{ texto  }}</p>
                <button id="btnInfo" v-if="btnModal" @click="validarCarga" class="btn btn-info mt-3" style="border-radius: 15px;">Comprobar información</button>
            </div>
        </CModal>
    </div>
    <!-- modal -->
    <div>
        <CModal :show.sync="modal.validar" ref="my-modal" :close-on-backdrop="false">
            <template #header-wrapper >
                <div class="text-center mb-3" >
                    <div class="row">
                    <div class="col-10"></div>
                    <div class="col-1 mt-2">
                        <button type="button" class="btn-close ml-4" aria-label="Close" @click="modal.validar = false"></button>
                        <!-- <button @click="modal.inicial = false" type="button" class="btn btn-light"> <i class="fas fa-times fa-2xl mt-3 mr-1" style="color:rgb(179, 173, 173);"></i></button> -->
                    </div>
                    </div>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
            <div class="card-body text-center">
            <img :src=imagen alt="" style="height: 90px;">
                <h3 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">{{ titulo }}</h3>
                <p class="mt-3">{{ texto  }}</p>
                <button id="btnInfo" v-if="btnModal" @click="validarModalMethod" class="btn btn-info mt-3" style="border-radius: 15px;">Comprobar información</button>
            </div>
        </CModal>
    </div>
     <!-- modal procesoAlta-->
     <div>
        <CModal :show.sync="modal.procesoAlta" ref="my-modal" :close-on-backdrop="false">
            <template #header-wrapper >
                <div class="text-center mb-3" >
                    <div class="row">
                    <div class="col-10"></div>
                    <div class="col-1 mt-2">
                        <!-- <button type="button" class="btn-close ml-4" aria-label="Close" @click="modal.procesoAlta = false"></button> -->
                        <!-- <button @click="modal.inicial = false" type="button" class="btn btn-light"> <i class="fas fa-times fa-2xl mt-3 mr-1" style="color:rgb(179, 173, 173);"></i></button> -->
                    </div>
                    </div>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
            <div class="card-body text-center" v-if="ejecuta_contador == 0">
                <img src="img/Logotipo Aula Latino2.png" alt="" style="height: 150px;">
                <h3 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">
                    Para terminar con el proceso de alta, da clic en el botón cotizar
                </h3>
                <button id="btnInfo" @click="cotizarGuardar" class="btn btn-info col-3 mt-3" style="border-radius: 15px;">Cotizar</button>
            </div>
            <div class="card-body text-center" v-if="ejecuta_contador == 1">
                <img src="img/Logotipo Aula Latino2.png" alt="" style="height: 150px;">
                <h3 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">
                    Carga de asegurados {{ psAvance_Asegurados }} de {{ psTotal_Asegurados }}
                </h3>
            </div>
        </CModal>
    </div>
    <!-- modal info-emitir-->
    <div>
        <CModal :show.sync="modal.info" ref="my-modal" :close-on-backdrop="false">
            <template #header-wrapper >
                <div class="text-center mb-3" >
                    <div class="row">
                    <div class="col-10"></div>
                    <div class="col-1 mt-2">
                        <button type="button" class="btn-close ml-4" aria-label="Close" @click="sinEmision"></button>
                        <!-- <button @click="modal.inicial = false" type="button" class="btn btn-light"> <i class="fas fa-times fa-2xl mt-3 mr-1" style="color:rgb(179, 173, 173);"></i></button> -->
                    </div>
                    </div>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
            <div class="card-body text-center">
                <img src="img/Logotipo Aula Latino2.png" alt="" style="height: 150px;">
                <h3 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">Se ha completado el alta de asegurados</h3>
                <h4 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">Prima neta: ${{arrCotizacion.IMP_PRIMA_NETA}} MXN</h4>
                <h4 class="text-center mt-3 titulosModal" >Derechos de póliza: ${{arrCotizacion.IMP_DERECHOS}} MXN</h4>
                <h4 class="text-center mt-3" style="color:rgb(112, 107, 107); font-weight:bold">I.V.A.: ${{arrCotizacion.IMP_IVA}} MXN</h4>
                <h3 class="text-center mt-3" style="color:#00b2e3; font-weight:bold">Total: ${{arrCotizacion.IMP_PRIMA_TOTAL}} MXN</h3>
                <p class="mt-4">Da clic en el botón si deseas realizar la emisón.</p>
                <button id="btnInfo" @click="emitir" class="btn btn-info col-3 " style="border-radius: 15px;">Emitir</button>
            </div>
        </CModal>
    </div>
    <!-- modal Agregar Registro-->
    <div>
        <CModal size="lg" :show.sync="modal.add" ref="my-modal" :close-on-backdrop="false">
            <template #header-wrapper >
                <div class="text-center mb-3" >
                    <div class="row">
                    <div class="col-md-10"></div>
                    <div class="col-md-2 mt-2">
                        <button type="button" class="btn-close ml-5" aria-label="Close" @click="modal.add = false"></button>

                        <!-- <button @click="modal.add = false" type="button" class="btn btn-light float-right mr-1"> <i class="fas fa-times fa-2xl mt-3 mr-1" style="color:rgb(179, 173, 173);"></i></button> -->
                    </div>
                    </div>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
            <div class="card-body">
                <h4 class="title">Agregar registro individual</h4>
                <div class="row">
                    <div class="col-md-6">
                        <Input
                        :type="'text'"
                        :inputClass="'form-control mb-2'"
                        :idInput="''"
                        :forLabel="''"
                        :label="'Apellido paterno'"
                        :placeholder="''"
                        :required="true"
                        :disabled="false"
                        />
                        <Input
                        :type="'text'"
                        :inputClass="'form-control mb-2'"
                        :idInput="''"
                        :forLabel="''"
                        :label="'Nombres'"
                        :placeholder="''"
                        :required="true"
                        :disabled="false"
                        />
                        <Input
                        :type="'text'"
                        :inputClass="'form-control mb-2'"
                        :idInput="''"
                        :forLabel="''"
                        :label="'Sexo'"
                        :placeholder="''"
                        :required="true"
                        :disabled="false"
                        />
                    </div>
                    <div class="col-md-6">
                        <Input
                        :type="'text'"
                        :inputClass="'form-control mb-2'"
                        :idInput="''"
                        :forLabel="''"
                        :label="'Apellido materno'"
                        :placeholder="''"
                        :required="true"
                        :disabled="false"
                        />
                        <Input
                        :type="'date'"
                        :inputClass="'form-control mb-2'"
                        :idInput="''"
                        :forLabel="''"
                        :label="'Fecha de nacimiento'"
                        :placeholder="''"
                        :required="true"
                        :disabled="false"
                        />
                    </div>
                </div>
                <button @click="addAsegurado" class="btn btn-info mt-3 float-right mb-5" style="border-radius: 15px;">Agregar asegurado</button>
            </div>
        </CModal>
    </div>
  </div>
</template>

<script>
import Input from "./tools/Input.vue";
import Select from "./tools/Select.vue";
import moment from 'moment';
import Vue from 'vue';
// Importamos JQuery
const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $



export default {
  components: {
    Input,
    Select,
  },
  data() {
    return {
      modal:{
        inicial: false,
        add: false,
        validar: false,
        procesoAlta: false,
        info: false
      },
      Archivo: "",
      titulo: "",
      texto: "",
      routeCot: "",
      routeVersion: "",
      idCarga: "",
      imagen: "",
      clase: "",
      paterno: "",
      materno: "",
      nombre: "",
      sexo: "",
      fecha: "",
      btnError: "",
      maxRenglones: "",
      validarModalError: "",
      listArchivo: [],
      camposError: [],
      camposErrorTemp: [],
      infoActualizada: [],
      infoCotizacion: [],
      catlineas: [],
      arrCotizacion: {},
      dataCarga: [],
      catProducto: [],
      editar: false,
      editarTxt: true,
      correcto: true,
      btnModal: true,
      closeModal: false,
      cargaExito: true,
      backBusqueda: false,
      numError: 0,
      min: 0,
      seconds: 0,
      defaultMinuteTime: 1,
      defaultSecondTime: 59,
      ejecuta_contador:0,
      psTotal_Asegurados: 0,
      psAvance_Asegurados: 0,
      psRestantes_Asegurados: 0
    }
  },
  methods: {
    validarModalMethod(){
        this.modal.validar = false
        if (this.validarModalError == 'error') {
            this.regresar()
        }
    },
    async fetchData() {
      let progress = 0; // Restablecer la barra de progreso
       let personasCargadas = 0; // Restablecer la cantidad de personas cargadas

      const startTime = Date.now();
      try {
        // Simulación de solicitud al endpoint
        const response = await this.catalogoLineas();
        console.log(response);
        // Manejo de la respuesta simulada
        if (response != '') {
          personasCargadas = 456; // Se establece la cantidad de personas cargadas al total
        }
      } catch (error) {
        // Manejo de errores
      }
      const endTime = Date.now();
      const tiempoDeRespuesta = endTime - startTime;

      // Ajusta el progreso de la barra en función del tiempo de respuesta
      progress = Math.min(Math.floor((personasCargadas / 456) * 100), 100);
      console.log(progress);
    },
    emitir(){
      this.modal.info = false
      window.location.href =`https://servicios.latinoseguros.com.mx/ClienteUnico/Acceso/Acceso.aspx?id=${localStorage.getItem("userId")}&idApp=10077`;
    },
    sinEmision(){
        this.modal.info = false;
        this.backBusqueda = true;
        this.modalExito('img/cotizador_APE/Check.png','¡Alta exitosa!', 'Si deseas consultarla después puedes hacerlo en la sección de Cotizaciones y Pólizas.', 'add')
        this.cargaExito = true;
    },
    async infoCotiz(){
        
    },
    regresar(){
        window.location.href = `/#/cotizador/escuelas/cargaListado?cot=${this.routeCot}&version=${this.routeVersion}&carga=${this.idCarga}`
    },
    async validarCarga() {
        let error = ""
        this.modal.inicial = false
        const payload = {
            metodo: "VALIDARCARGA",
            data: {
                peID_COTIZACION: this.routeCot,
                peID_VERSION_POL: this.routeVersion,
                pesID_CARGA: this.idCarga,
                pIdUsuarioLogueado: localStorage.getItem("userId"), 
                peID_LINEA_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO
            },
        };
        console.log(payload);
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.camposError = res.Table1
                this.maxRenglones = res.Table2[0].MaxRenglones
                this.closeModal = false;
                if(this.camposError.length > 0) {
                    // this.modalExito('img/cotizador_APE/Tache.png', '¡Tu registro muestra errores!', 'Da clic en el botón para hacer la pre validación antes de dar el alta de asegurados.')
                    for (let e = 0; e < this.camposError.length; e++) {
                        if (this.camposError[e].Renglon != null) {
                            let fecha = this.camposError[e].FechadeNacimientodiamesaño.split("/");
                            this.camposError[e].fechaFormateada = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                            this.camposError[e].Editar = false;
                            if(this.camposError[e].ErrorDetectado == 'Existe en la carga'){
                                this.camposError[e].btnError = "";
                            } else {
                                this.camposError[e].btnError = "Error";
                            }
                            // this.camposError[e].Txt = true;
                            this.btnError = "Error"
                        }
                        this.numError = this.camposError.length
                    }
                    
                    // this.camposErrorTemp = this.camposError;
                } else {
                    // this.modalExito('img/cotizador_APE/check.png','¡Tu archivo se ha cargado con éxito!', 'Da clic en el botón para hacer la pre validación antes de dar el alta de asegurados.', 'add') 
                }
                console.log(this.camposError);
            } else {
                error = this.$store.getters.getDataRaw.errorMessage
                this.modalExito('img/cotizador_APE/Tache.png',error, '', 'add')
                this.cargaExito = true;
                this.closeModal = true;
            }
        } //Fin try
        catch (error) {
            console.log(error);
      }
    },
    async validarCargaActualizada() {
        this.validarModalError = ''
        this.numError = 0;
        const payload = {
        metodo: "VALIDACARGAACTUALIZADAAPE",
        data: {
            peID_COTIZACION: this.routeCot,
            peID_VERSION_POL: this.routeVersion,
            pesID_CARGA: this.idCarga,
            pIdUsuarioLogueado: localStorage.getItem("userId"), 
            MaxRenglones: this.maxRenglones,
            pInfo: this.infoActualizada,
            peID_LINEA_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO
        },
        };
        console.log(payload);
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                console.log(res);
                
                this.camposError = res.Table1
                this.camposError.map((elemento, i) => {
                    if(elemento.ErrorDetectado == null){
                        elemento.btnError = ""
                    } else {
                        elemento.btnError = "Error"
                        this.numError = this.numError + 1
                        this.modalValidar('img/cotizador_APE/Tache.png','¡Tu registro muestra errores!', 'Da clic en el botón para hacer la pre validación antes de dar el alta de asegurados.')
                    }
                    if (elemento.Renglon != null) {
                        let fecha = elemento.FechadeNacimientodiamesaño.split("/");
                        elemento.fechaFormateada = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                    } 
                    if(this.numError == 0){
                        this.modalValidar('img/cotizador_APE/Check.png','¡Tu archivo se ha actualizado con éxito!', 'Da clic en el botón para hacer la pre validación antes de dar el alta de asegurados.')
                    }
                })
                console.log(this.camposError);

            } else {
                let error = this.$store.getters.getDataRaw.errorMessage
                this.modalValidar('img/cotizador_APE/Tache.png',error, '')
                this.validarModalError = 'error'
            }
        } //Fin try
        catch (error) {
            console.log(error);
      }
    },
    async grabarCarga() {
        const payload = {
            metodo: "GRABARCARGAAPE",
                data: {
                    peID_COTIZACION: this.routeCot,
                    peID_VERSION_POL: this.routeVersion,
                    pesID_CARGA: this.idCarga,
                    pIdUsuarioLogueado: localStorage.getItem("userId"), 
                    MaxRenglones: this.maxRenglones,
                    pInfo: this.infoActualizada,
                    peID_LINEA_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO
                },
        };
        console.log(payload);
        try {
            const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                console.log(res);
                this.modal.procesoAlta = true;
                this.dataCarga = res[0];
            } else {
                let error = this.$store.getters.getDataRaw.errorMessage
                this.modalValidar('img/cotizador_APE/Tache.png',error, '')
                console.log(error);
            }
        } //Fin try
        catch (error) {
            console.log(error);
      }
    },
    addAsegurado(){
        this.closeModal = false;
        this.modalExito('¡Alta individual completa!', 'Cierra esta ventana para revisar que se encuentre el alta en el listado.', 'add')
        this.cargaExito = true;
    },
    modalClose(){
        if(this.closeModal){
            this.regresar()
        } else if(this.backBusqueda) {
            window.location.href = `/#/cotizador/escuelas/cotizaciones`

        }
        else {
            this.modal.inicial = false
        }
    },
    modalExito(img, title, text, condicion){
      this.imagen = img
      this.modal.inicial = true;
      this.titulo = title
      this.texto = text
      if(condicion == 'add'){
        this.modal.add = false;
        this.btnModal = false;
      }
    },
    modalValidar(img, title, text){
      this.imagen = img
      this.modal.validar = true;
      this.titulo = title
      this.texto = text
    },
    editarRegistro: function(item, index){
        item.Editar = true;
        this.$set(this.camposError, index, item);
    },
    eliminar(i, item){
        this.camposError.splice(i,1)
        console.log(this.camposError);
        setTimeout( () => {
            this.actualizarRegistro(item, i, this.camposError)
        }, 1000)
        // this.actualizarEliminado = true
    },
    actualizarRegistro(item, index, arrEliminados){
        // this.modalExito('¡Tu archivo se ha actualizado con éxito!', 'Da clic en el botón para hacer la pre validación antes de dar el alta de asegurados.')
        console.log(arrEliminados);
        if(arrEliminados != undefined){
            console.log("entra");

            let arrInfo = [];
            for (let e = 0; e < arrEliminados.length; e++) {
                if (arrEliminados[e].Renglon != null) {
                    let fecha = arrEliminados[e].fechaFormateada.split("-")
                    arrEliminados[e].FechadeNacimientodiamesaño = fecha[2] + "/" + fecha[1] + "/" + fecha[0];
                }
                let actualizado = {
                    ApellidoPaterno: arrEliminados[e].ApellidoPaterno.toUpperCase(),
                    ApellidoMaterno: arrEliminados[e].ApellidoMaterno.toUpperCase(),
                    Nombres: arrEliminados[e].Nombres.toUpperCase(),
                    SexoMF:arrEliminados[e].SexoMF,
                    FechadeNacimientodiamesaño: arrEliminados[e].FechadeNacimientodiamesaño,
                    Valido: "",
                    Renglon:arrEliminados[e].Renglon,
                }
                arrInfo.push(actualizado)
            }
            // console.log(this.camposError);
            console.log(arrInfo);
            this.infoActualizada = arrInfo;
            return;
        }
        console.log("entra2");
        item.Editar = false;
        this.$set(this.camposError, index, item);

        let arrInfo = [];
        console.log(this.camposError);
        for (let e = 0; e < this.camposError.length; e++) {
            if (this.camposError[e].Renglon != null) {
                let fecha = this.camposError[e].fechaFormateada.split("-")
                this.camposError[e].FechadeNacimientodiamesaño = fecha[2] + "/" + fecha[1] + "/" + fecha[0];
            }
            let actualizado = {
                ApellidoPaterno: this.camposError[e].ApellidoPaterno.toUpperCase(),
                ApellidoMaterno: this.camposError[e].ApellidoMaterno.toUpperCase(),
                Nombres: this.camposError[e].Nombres.toUpperCase(),
                SexoMF: this.camposError[e].SexoMF,
                FechadeNacimientodiamesaño: this.camposError[e].FechadeNacimientodiamesaño,
                Valido: "",
                Renglon: this.camposError[e].Renglon,
            }
            arrInfo.push(actualizado)
        }
        // console.log(this.camposError);
        console.log(arrInfo);
        this.infoActualizada = arrInfo;
    },
    async buscaCotiz(){
      const payload = {
        metodo: "BURCARCOTIZACIONAPE",
        data: {
          PEID_COTIZACION: this.routeCot,
          PEID_VERSION_POL: this.routeVersion,
          PEID_LINEA_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO,
          pIdUsuarioLogueado: localStorage.getItem("userId"),
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      try {
        if (res) {
          const cotiz = this.$store.getters.getRespuestaREST;
          this.infoCotizacion = cotiz
          console.log(this.infoCotizacion);
          this.catalogoLineas()
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    async catalogoProductos(){
      const payload = {
        metodo: "CATPRODUTOSAPE",
        data: {
          pId_Empresa: "8",
          pId_Agente: localStorage.getItem("userId") 
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const productos = this.$store.getters.getRespuestaREST;
        this.catProducto = productos[0];
        console.log(this.catProducto);
      }
    },
    async catalogoLineas(){
      const payload = {
        metodo: "CATLINEASAPE",
        data: {
          pId_Empresa: "8",
          pId_Producto: this.catProducto.ID_PRODUCTO,
          pId_Version: this.catProducto.ID_VERSION,
          pId_Agente: localStorage.getItem("userId") 
        },
      };
      console.log(payload);
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const lineas = this.$store.getters.getRespuestaREST;
        this.catlineas = lineas[0];
        console.log(this.catlineas);
      }
    },
    async cotizarGuardar(){
        console.log(this.infoCotizacion);
        let cobertura = this.infoCotizacion.COBERTURAS.map(obj => {
            if(obj.ID_COBERTURA == 769){ return obj.SA_AMPARADA_FORMATEADA;}
            if(obj.ID_COBERTURA == 1097){ return obj.SA_AMPARADA_FORMATEADA;}
            if(obj.ID_COBERTURA == 1080){ return obj.SA_AMPARADA_FORMATEADA;}
            if(obj.ID_COBERTURA == 877){ return obj.SA_AMPARADA_FORMATEADA;}
        })
        console.log(cobertura);
      const payload = {
        metodo: "GRABARCOTIZACIONAPE",
        data: {
            peID_COTIZACION: this.routeCot,
            peID_VERSION_POL: this.routeVersion, 
            numeromatriculaCat1: this.dataCarga.numeromatriculaCat1,
            numeromatriculaCat2: this.dataCarga.numeromatriculaCat2,
            numeromatriculaCat3: this.dataCarga.numeromatriculaCat3,
            numeromatriculaCat4: this.dataCarga.numeromatriculaCat4,
            peID_SECUENCIA: "1",
            peSA_AMPARADA_MTE_Id: "769",
            peSA_AMPARADA_MTE_SA: cobertura[0],
            // peSA_AMPARADA_MTE_SA: this.infoCotizacion.SA_AMPARADA_MTE.split("-")[1],
            peSA_AMPARADA_GF_Id: "1097",
            peSA_AMPARADA_GF_SA: cobertura[1],
            peSA_AMPARADA_PO_Id: "1080",
            peSA_AMPARADA_PO_SA: cobertura[2],
            peSA_AMPARADA_PO_Valor: this.infoCotizacion.CVE_T_RIESGO_PER,
            peSA_AMPARADA_RGM_Id: "877",
            peSA_AMPARADA_RGM_SA: cobertura[3],
            peSA_AMPARADA_RGM_Valor: this.infoCotizacion.CVE_T_INDEMNIZA,
            peDEDUCIBLE: this.infoCotizacion.IMP_DEDUCIBLE,
            peID_USUARIO: "WEB",
            peId_Rol: localStorage.getItem("idRol"),
            peEsCargaReal: "1",
            pesID_USUARIO_LOGUEADO: localStorage.getItem("userId"),
            datos: {
              pid_empresa: "8",
              pid_cotizacion: this.routeCot,
              pId_Version_Pol: "1", 
              pf_ini_vigencia:  this.infoCotizacion.F_INI_VIGENCIA,
              pid_producto:  this.infoCotizacion.ID_PRODUCTO,
              pid_version: this.infoCotizacion.ID_VERSION_POL,
              Pidformapago: this.infoCotizacion.ID_FORMA_PAGO,
              pid_moneda: this.infoCotizacion.ID_MONEDA.toString(),
              pId_Agente: localStorage.getItem("userId"),
              pid_usuario: "WEB",
              pid_lin_negocio: this.infoCotizacion.ID_LIN_NEGOCIO,
              pCve_T_Bien: this.catlineas.CVE_T_BIEN,
              PNomp_solicitante: this.infoCotizacion.DESC_COLEGIO,
              pPct_IVA: "16",
              peplazobasico: this.infoCotizacion.PLAZOBASICO,
              peIdContratante: null,
              peIdDomicilio: null,
              pePCT_COB_RGM: this.infoCotizacion.PCT_COB_RGM,
              peCveTIndemniza: this.infoCotizacion.CVE_T_INDEMNIZA,
              peCveTRiesgoPer: this.infoCotizacion.CVE_T_RIESGO_PER,
              peDESC_CARACTER: this.infoCotizacion.DESC_CARACTER_Arreglo.toString(),
              peIDCARGA: this.infoCotizacion.ID_CARGA,
              peNIVEL_ESCOLAR_A: this.infoCotizacion.NIVEL_ESCOLAR_A == "" ? null : this.infoCotizacion.NIVEL_ESCOLAR_A ,
              peNIVEL_ESCOLAR_B: this.infoCotizacion.NIVEL_ESCOLAR_B  == "" ? null : this.infoCotizacion.NIVEL_ESCOLAR_B,
              peNIVEL_ESCOLAR_C: this.infoCotizacion.NIVEL_ESCOLAR_C == "" ? null : this.infoCotizacion.NIVEL_ESCOLAR_C,
              peNIVEL_ESCOLAR_D: this.infoCotizacion.NIVEL_ESCOLAR_D == "" ? null : this.infoCotizacion.NIVEL_ESCOLAR_D,
              peNIVEL_ESCOLAR_E: this.infoCotizacion.NIVEL_ESCOLAR_E == "" ? null : this.infoCotizacion.NIVEL_ESCOLAR_E,
              peNIVEL_ESCOLAR_F: this.infoCotizacion.NIVEL_ESCOLAR_F == "" ? null : this.infoCotizacion.NIVEL_ESCOLAR_F,
              peDESC_COLEGIO: this.infoCotizacion.DESC_COLEGIO,
              peH_MATUTINO_D: this.infoCotizacion.H_MATUTINO_D,
              peH_MATUTINO_H: this.infoCotizacion.H_MATUTINO_H,
              peH_VESPERTINO_D: null,
              peH_VESPERTINO_H: null,
              pCiclo_Escolar: this.infoCotizacion.CICLO_ESCOLAR,
              PeID_Usuario: "WEB",
              pcve_sist_admon: this.infoCotizacion.CVE_SIST_ADMON || "N"
            }
        },
      };

      console.log(payload);
      console.info("se envia la cotización para la carga real de asegurados");

      //const res = await 

      //this.ejecuta_contador = 1;
      this.$store.dispatch("metodoPost", payload);

      /*starTimerVerifyCode() {
        this.min = this.defaultMinuteTime;
        this.seconds = this.defaultSecondTime;

        let timerStar = setInterval(() => {
            this.seconds--;

            if (this.seconds === 0 && this.min > 0) {
            this.min--;
            this.seconds = 59;
            }

            if (this.seconds <= 0 && this.min <= 0) {
            clearInterval(timerStar);
            }
        }, 1000);
        },*/

      try {
        this.min = this.defaultMinuteTime;
        this.seconds = this.defaultSecondTime;

        let timerStar = setInterval(() => {
            this.contador(timerStar);

            /*this.seconds--;

            if (this.seconds === 0 && this.min > 0) {
                this.min--;
                this.seconds = 59;
            }

            if (this.seconds <= 0 && this.min <= 0) {
                clearInterval(timerStar);
            }*/

            /*if (res) {
                const guardar = this.$store.getters.getRespuestaREST;
                console.log(guardar);
                this.arrCotizacion = guardar;
                this.modal.procesoAlta = false
                this.modal.info = true;

            } else {
                let error = this.$store.getters.getDataRaw.errorMessage
                this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: error,
                    }).then( () => {
                        this.regresar()
                    });
            }*/
        }, 3000);
      } catch (error) {
        console.log(error);
        this.$swal({
              icon: 'error',
              title: 'Error',
              text: "Error al guardar la cotización.",
            }).then( () => {
                this.regresar()
            });
      }
    },
    async contador(timerStar){
        const payload = {
                metodo: "CONTADORAPE",
                data: {
                    peID_COTIZACION: this.routeCot,
                    peID_VERSION_POL: this.routeVersion,
                    pIdUsuarioLogueado: localStorage.getItem("userId")
                }
        };

        const res = await this.$store.dispatch("metodoPostOutLoading", payload);

        if (res) {
            const contador_resp = this.$store.getters.getRespuestaREST;
            console.log(contador_resp);
            this.psAvance_Asegurados = contador_resp.psAvance_Asegurados;
            this.psTotal_Asegurados = contador_resp.psTotal_Asegurados;
            this.psRestantes_Asegurados = contador_resp.psRestantes_Asegurados;
            this.$store.dispatch("hideLoadingStore");
            this.ejecuta_contador = 1;

            if(contador_resp.psRestantes_Asegurados == 0){
                clearInterval(timerStar);
                this.cargaCotizacionReal();
            }
        }
    },
    async cargaCotizacionReal(){
      this.condiciones = false
      const payload = {
        metodo: "BURCARCOTIZACIONAPE",
        data: {
          PEID_COTIZACION: this.routeCot,
          PEID_VERSION_POL: this.routeVersion,
          PEID_LINEA_NEGOCIO: this.catlineas.ID_LIN_NEGOCIO,
          pIdUsuarioLogueado: localStorage.getItem("userId")
        }
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      try {
            if (res) {
                const cotizacionReal = this.$store.getters.getRespuestaREST;
                console.log("busca cotizacion");
                console.log(cotizacionReal);
                this.arrCotizacion = cotizacionReal;
                this.modal.procesoAlta = false
                this.modal.info = true;
            }
      }
      catch (error) {
        console.log(error);
      }
    }
  },
  async mounted() {
    this.catalogoProductos()
    this.cargaExito = false;
    this.modalExito('img/cotizador_APE/Check.png','¡Tu archivo se ha cargado con éxito!', 'Da clic en el botón para hacer la pre validación antes de dar el alta de asegurados.')
    this.routeCot = this.$route.query.cot;
    this.routeVersion = this.$route.query.version;
    this.idCarga = this.$route.query.carga;
    setTimeout(async() =>{
        const promise = new Promise((resolve, _) => {
            resolve(
                this.catalogoLineas()
            );
            });
            promise.then(_ => {
                this.buscaCotiz()
            }
        );
    }, 1000);
  },

}
</script>

<style>
.titulosModal {
    color:rgb(112, 107, 107); 
    font-weight:bold;
    line-height: 0; 
}
.btns{
    background-color: white;
}
.editar{
    background-color: rgb(0, 0, 0);
}
.registroDuplicado{
    background-color: rgb(0, 128, 0);
    color: #ffffff;
}
.nombreVacio{
    background-color: rgb(128, 0, 128);
    color: #ffffff;
}
.apellidopVacio{
    background-color: rgb(0, 139, 139);
    color: #ffffff;
}
.apellidomVacio{
    background-color: rgb(255, 0, 0);
    color: #ffffff;
}
.sexoVacio{
    background-color: #ffffff;
    border: 2px solid rgb(0, 0, 0);;
}
.edadMenor{
    background-color: rgb(255, 255, 0);
}
.edadMayor{
    background-color: rgb(255, 0, 0);
    color: #ffffff;
    /* border-bottom: 2px solid rgb(0, 0, 0); */
}
.alta{
    background-color: rgb(0, 139, 139);
    color: #ffffff;
}
.c_diferentes{
    background-color: #EB21B6;
    color: #ffffff;
}
.dupicado{
    background-color: #008000;
    color: #ffffff;
}
.btnTabla{
border: #ffffff;
}
.tr-table{
    background-color: #008000; 
    color: rgb(254, 254, 255);
}
.td-table-button{
    background-color: #ffffff;
}
.btn-table-edit{
    background-color: #000000; 
    color: rgb(255, 208, 0);
}
.circulo {
     width: 14px;
     height: 14px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;

}
.bordeCirculo{
    border: 2px solid rgb(0, 0, 0);
}
.card{
  border-radius: 30px;
  box-shadow: 5px 5px 10px rgb(206, 204, 204);
}
.title{
  color: rgb(45, 54, 139);
  font-weight: bold;
}
.border{
  border-radius: 15px;
  font-weight: bold;

}
</style>